exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ctn-data-card-tbl table td {\n  margin-right: 20px;\n  background: #fff;\n  padding-top: 0;\n  margin: 0; }\n  .ctn-data-card-tbl table td:last-child {\n    padding-right: 0; }\n\n.w-160 {\n  width: 160px;\n  min-width: 160px;\n  max-width: 160px; }\n\n.bg-white {\n  background: #fff; }\n\n.left {\n  float: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card/data-card.component.scss
// module id = ../../../../../src/app/brds/widgets/data-cards/data-card/data-card.component.scss
// module chunks = 10